import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/user";
import { openConsoleAdminPage } from "@/utils/common";

interface NetError {
    code: string;
    i18n: string;
    field: string;
    message: string;
}

function getErrorMsg(error: NetError) {
    const whiteList = ["00000404"];

    if (!whiteList.includes(error.code)) {
        return error.message ? `${error.message}` : "";
    }
}
// 登录失效 多接口调用 显示多个提示
let showMsg = true;

/**
 * @description: 校验网络请求状态码
 * @return void
 * @param response
 */
export const checkStatus = async (response: any) => {
    let errorMessage = "";
    const { status } = response;
    if (status === 400) {
        const errors = response.data?.errors;
        if (errors !== null && errors?.length > 0) {
            const errorMsgs = errors.map(getErrorMsg);
            errorMessage = errorMsgs.join("<br />");
        } else {
            errorMessage = response.data?.message || response.data?.detail;
        }
    } else {
        const code = response.data?.code;
        switch (status) {
            case 401:
                // 未绑定微信
                if (code === "20001010") {
                    break;
                }
                // 无效的code或者code已过期
                if (code === "20001002") {
                    break;
                }

                // 用户PC端，登录失败 对接后端返回提示
                errorMessage = response.data?.message || response.data?.detail;
                if (code === "401") {
                    const userStore = useUserStore();
                    userStore.clear();
                    openConsoleAdminPage("/login");
                    if (showMsg) {
                        errorMessage = "登录失效！";
                        showMsg = false;
                        setTimeout(() => {
                            showMsg = true;
                        }, 1000);
                    } else {
                        errorMessage = "";
                    }
                }
                break;
            case 403:
                errorMessage = "当前账号无权限访问！";
                if (code === "20001008") {
                    errorMessage = response.data?.message;
                }
                break;
            case 404:
                errorMessage = "你所访问的资源不存在！";
                break;
            case 405:
                errorMessage = "请求方式错误！请您稍后重试";
                break;
            case 408:
                errorMessage = "请求超时！请您稍后重试";
                break;
            case 500:
                errorMessage = "服务异常！请联系系统管理员！";
                break;
            case 502:
                errorMessage = "网关错误！请联系系统管理员！";
                break;
            case 503:
                errorMessage = "服务不可用！请联系系统管理员！";
                break;
            case 504:
                errorMessage = "网关超时！请联系系统管理员！";
                break;
            default:
                errorMessage = "请求失败！";
        }
    }

    if (errorMessage) {
        ElMessage.error({
            dangerouslyUseHTMLString: true,
            message: errorMessage,
            customClass: "captcha"
        });
    }
};
